import {z} from '@hono/zod-openapi';

/** XML 1.0 character set; escaping cannot make forbidden controls or lone surrogates valid. */
export const hondaReportTextSchema = z
  .string()
  .refine(
    (value) =>
      Array.from(value).every((character) => {
        const point = character.codePointAt(0) ?? 0;
        return (
          point === 0x09 ||
          point === 0x0a ||
          point === 0x0d ||
          (point >= 0x20 && point <= 0xd7ff) ||
          (point >= 0xe000 && point <= 0xfffd) ||
          (point >= 0x10000 && point <= 0x10ffff)
        );
      }),
    'Text contains a character that XML 1.0 cannot represent'
  )
  .openapi('HondaReportText');
